import axios from 'axios';

export const sincronizadorApi = axios.create({
    baseURL: `${process.env.REACT_APP_SINCRONIZADOR_API}`,
});

